import React, { useState } from "react";
import GameNav from "./GameNav";
import TabsContent from "./TabsContent";
import { tabsData } from "../../helper/Helper";

function GamShow() {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <>
      <div className="wrapper mx-auto pb-0 pt-4 py-md-4">
        <GameNav
          tabs={tabsData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
      <TabsContent tabs={tabsData} activeTab={activeTab} />
    </>
  );
}

export default GamShow;
